import React from "react";

function Header(){

    return(
        <div>
                <title>Crypto Wave Jade Coral</title>
                <meta charSet="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta httpEquiv="refresh" content="1500" />
                <link rel="icon" type="image/x-icon" href="favicon.ico" />
                <link rel="stylesheet" href="styles.css"></link>
        </div>
    )
}

export default Header;